/* eslint-disable promise/no-return-wrap */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-await-in-loop */
/* eslint-disable promise/always-return */
/* eslint-disable no-param-reassign */
/* eslint-disable promise/catch-or-return */
import axios from 'axios';
import { Auth } from '@aws-amplify/auth';
import { getLoginUrl } from './auth';

const baseURL = process.env.GATSBY_API_URL || 'http://localhost:8000';

const signOutToLogin = () =>
  Auth.signOut().then(() => {
    localStorage.removeItem('me');
    window.location.href = getLoginUrl(window.location.href);
  });

const instance = axios.create({
  baseURL,
});

instance.interceptors.request.use(
  async (config): Promise<any> =>
    new Promise((resolve) => {
      Auth.currentSession()
        .then((session) => {
          const idTokenExpire = session.getAccessToken().getExpiration();
          const refreshToken = session.getRefreshToken();
          const currentTimeSeconds = Math.round(+new Date() / 1000);
          if (idTokenExpire < currentTimeSeconds) {
            Auth.currentAuthenticatedUser().then((res) => {
              res.refreshSession(
                refreshToken,
                (
                  err: any,
                  data: {
                    getAccessToken: () => {
                      (): any;
                      new (): any;
                      getJwtToken: { (): any; new (): any };
                    };
                  },
                ) => {
                  if (err) {
                    signOutToLogin();
                  } else {
                    config.headers.Authorization = `Bearer ${data
                      .getAccessToken()
                      .getJwtToken()}`;
                    resolve(config);
                  }
                },
              );
            });
          } else {
            config.headers.Authorization = `Bearer ${session
              .getAccessToken()
              .getJwtToken()}`;
            resolve(config);
          }
        })
        .catch(() => {
          signOutToLogin();
          // No logged-in user: don't set auth header
          resolve(config);
        });
    }),
);

export default instance;
